import Api from '@/axios/api'
import { API_TOKEN_PRESETS } from '@/constants/apiTokenPresets'

export default {
  namespaced: true,

  state: () => ({
    loading: false,
    items: []
  }),

  actions: {
    async load ({ state }) {
      state.loading = true

      return await Api.get('/customer/tokens')
        .then(response => {
          state.items = response.data
          state.loading = false
        })
    },
    async create ({ state, dispatch }, { name, preset = API_TOKEN_PRESETS.INTEGRATION }) {
      return await Api.post('/customer/tokens', {
        name,
        preset
      })
        .then(response => {
          dispatch('load')
          return response
        })
    },
    async destroy ({ state, dispatch }, token) {
      return await Api.delete('/customer/tokens/' + token.id)
        .then(response => {
          dispatch('load')
        })
    }
  }
}
